import Skeleton from "@mui/material/Skeleton";
import * as Card from "@volt_developers/components/components/Card";
import { getSpacing } from "@volt_developers/foundations";

interface CardItemLoadableProps extends Card.ItemComponentProps {
  isLoading?: boolean;
}

export function CardItemLoadable({
  isLoading,
  ...other
}: CardItemLoadableProps) {
  if (isLoading) {
    return (
      <Card.Item {...other}>
        <Skeleton sx={{ lineHeight: getSpacing(6), width: "50%" }} />
      </Card.Item>
    );
  }

  return <Card.Item {...other} />;
}
